import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HlmToasterComponent } from '@shared/spartan/ui-sonner-helm/src';
import { environment } from '@env/environment';
import { BackgroundExecutionService } from '@core/services/background-execution.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToasterComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  constructor() {
    // Eagerly instantiate the service so it reconnects to any persisted background
    // jobs from localStorage before the first route component renders.
    inject(BackgroundExecutionService);
  }
}
